import React, {Component} from 'react';
import './SearchUserTypeSelector.css';

class SearchUserTypeSelector extends Component {
	render() {
		const {
			setSearchProvider,
			setSearchCommunity,
			setSearchUser,
			searchFor,
			compact = false,
			radii = true,
			invert = false
		} = this.props;

		return (
			<ul
				className={`SearchUserTypeSelector ${compact ? 'compact' : ''} ${radii ? 'radii' : ''} ${
					invert ? 'invert' : ''
				}`}>
				<li className={searchFor === 'provider' ? 'selected' : ''} onClick={setSearchProvider}>
					<span className="icon icon-face" />
					<span>
						{compact ? 'Providers' : 'Search for a '}
						{compact ? '' : <em>Provider</em>}
					</span>
				</li>
				<li className={searchFor === 'community' ? 'selected' : ''} onClick={setSearchCommunity}>
					<span className="icon icon-people" />
					<span>
						{compact ? 'Communities' : 'Search for a '}
						{compact ? '' : <em>Community</em>}
					</span>
				</li>
				<li className={searchFor === 'user' ? 'selected' : ''} onClick={setSearchUser}>
					<span className="icon icon-person" />
					<span>
						{compact ? 'Users' : 'Search for a '}
						{compact ? '' : <em>User</em>}
					</span>
				</li>
			</ul>
		);
	}
}

export default SearchUserTypeSelector;



// WEBPACK FOOTER //
// ./src/search/SearchUserTypeSelector.js